var env = __env__;
var projEnv = require(`../../config/${env}.env`);

var state = {
  queryObj: {},
  window: {
    width: 0,
    height: 0
  },
  proConfig: projEnv,
  awardRole: {
    name: ''
  },
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js